import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Roboto\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"700\"],\"subsets\":[\"latin\",\"vietnamese\"],\"display\":\"optional\",\"variable\":\"--font-roboto\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Montserrat\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"subsets\":[\"latin\",\"vietnamese\"],\"display\":\"optional\",\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/skin-bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/color.min.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/mobile-nav.min.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/theme.min.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/custom-css.min.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/responsive.min.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css-global/global-overrides.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/primereact/resources/primereact.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/primeflex/primeflex.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/primeicons/primeicons.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/primereact/resources/themes/lara-light-indigo/theme.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/admin/AdminLayout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/footer/ZaloButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/footer/ZaloButton2.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/GoogleTagManager.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/header/MainHeader.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/LegacyScripts.js");
